import { useRef } from 'react';
import { useMemoizedFn } from 'ahooks';
import {
  usePaneHeight,
  useSetPaneHeight,
} from 'hooks/business/conversationsHooks/useConversationPane';

const PANE_MIN_HEIGHT = 180;
const PANE_MAX_HEIGHT = 360;

/**
 * 消息编辑器窗格拖拽高度
 * 单一职责：管理可拖拽的编辑区域高度
 */
export function useMessageEditorPaneResize(
  minHeight: number = PANE_MIN_HEIGHT,
  maxHeight: number = PANE_MAX_HEIGHT,
) {
  const paneRef = useRef<HTMLDivElement>(null);
  const paneHeight = usePaneHeight();
  const setPaneHeight = useSetPaneHeight();

  const onSplitMouseDown = useMemoizedFn((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const startHeight = event.clientY;
    const currentPaneHeight = paneRef.current?.getBoundingClientRect().height ?? 0;
    event.preventDefault();

    const mousemove = (e: MouseEvent) => {
      requestAnimationFrame(() => {
        const calH = startHeight - e.clientY;
        const newPaneHeight = currentPaneHeight + calH;
        if (newPaneHeight > maxHeight) {
          document.body.style.cursor = 's-resize';
        } else if (newPaneHeight < minHeight) {
          document.body.style.cursor = 'n-resize';
        } else {
          document.body.style.cursor = 'row-resize';
          setPaneHeight(calH + currentPaneHeight, true);
        }
      });
    };
    const mouseup = () => {
      requestAnimationFrame(() => {
        document.body.style.cursor = '';
      });
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    };
    document.addEventListener('mouseup', mouseup);
    document.addEventListener('mousemove', mousemove);
  });

  return {
    paneRef,
    paneHeight,
    setPaneHeight,
    onSplitMouseDown,
  };
}
